<template>
  <div class="market-create-container">
    <NavHeaderBar :showSearch="false" :navBarTitle="formData.surveyName"></NavHeaderBar>
    <div class="form-content">
      <div class="info">
        <div class="item-title">{{ $t('form.basicInfo') }}</div>
        <div class="form-item">
          <div class="label">
            <span>{{ $t('form.month') }}</span>
          </div>
          <van-field v-model="originalData.month" placeholder="" readonly label-align="top" class="custom-field" disabled />
        </div>
        <div class="form-item">
          <div class="label required">
            <span>{{ $t('form.country') }}</span>
          </div>
          <!-- <van-field v-model="originalData.country" placeholder="" :border="false" class="custom-field" :disabled="statusDisable" /> -->
          <XuSelect v-model="originalData.country" :dataOptions="globalData.countryList" :disabled="statusDisable" />
        </div>
      </div>
      <div class="info">
        <div class="item-title title-custom">
          <span class="left-title">{{ $t('form.productInfo') }}.</span>
          <span v-if="!statusDisable" class="right-group" @click="toUrl">+ {{ $t('button.addProduct') }}</span>
        </div>
        <div class="product-item" v-for="(subItem, subIndex) in originalData.rivalList" :key="subIndex">
          <div class="product-header">
            <div class="title-txt">
              <div class="product-name">{{ subItem.productName }}</div>
              <!-- 品牌名称 · 系列名称 · 品类名称 -->
              <div class="other-name">{{ subItem.brand }} · {{ subItem.series }} · {{ subItem.category }}</div>
            </div>
            <img v-if="!statusDisable" class="remove-icon" src="@/assets/images/event_del.png" alt="" @click="handleOper('del', subIndex)">
          </div>
          <div class="product-form">
            <van-collapse v-model="subItem.activeNames" @change="handleCollapse(subItem)">
              <van-collapse-item title="" name="1">
                <template #title>
                  <!-- 市场信息收集 -->
                  <div class="collapse-title"><van-icon name="description-o" class="desc-icon" /> <span>{{ $t('form.marketInformationCollection') }}</span> </div>
                </template>
                <div class="form-item product-form-item">
                  <div class="label required">
                    <!-- EXW预估价格 -->
                    <span>{{ $t('form.eXWEstimatedPrice') }}</span>
                  </div>
                  <van-field v-model="subItem.exwEstimatePrice" :disabled="statusDisable" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label">
                    <!-- MD批发价 -->
                    <span>{{ $t('form.mDWholesalePrice') }}</span>
                  </div>
                  <van-field v-model="subItem.mdDealerPrice" :disabled="statusDisable" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label">
                    <!-- 门店采购价 -->
                    <span>{{ $t('form.storePurchasePrice') }}</span>
                  </div>
                  <van-field v-model="subItem.storePurchasePrice" :disabled="statusDisable" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label required">
                    <!-- 终端价 -->
                    <span>{{ $t('form.retailPriceMoney') }}</span>
                  </div>
                  <van-field v-model="subItem.retailPrice" :disabled="statusDisable" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label required">
                    <!-- 套装月均销量 -->
                    <span>{{ $t('form.monthlyAverageSalesForKit') }}</span>
                  </div>
                  <van-field v-model="subItem.avgMonthSale" :disabled="statusDisable" type="digit" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label required">
                    <!-- 耗材比(弹杆比/芯机比) -->
                    <span>{{ $t('form.consumablesRatio') }}</span>
                  </div>
                  <van-field v-model="subItem.supplyRatio" :disabled="statusDisable" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label required">
                    <!-- 耗材 EXW预估价 -->
                    <span>{{ $t('form.estimatedPriceOfConsumablesEXW') }}</span>
                  </div>
                  <van-field v-model="subItem.supplyExwPrice" :disabled="statusDisable" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label">
                    <!-- 市场反馈 -->
                    <span>{{ $t('form.marketFeedback') }}</span>
                  </div>
                  <van-field v-model="subItem.marketFeedback" :disabled="statusDisable" type="textarea" show-word-limit rows="3" class="custom-field field-textarea" />
                </div>
                <div class="form-item product-form-item">
                  <div class="label">
                    <!-- 活动政策 -->
                    <span>{{ $t('shared.eventPolicy') }}</span>
                  </div>
                  <van-field v-model="subItem.campaignPolicy" :disabled="statusDisable" type="textarea" show-word-limit rows="3" class="custom-field field-textarea" />
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="oper-btn" v-if="!statusDisable">
      <van-button class="mapping-btn" type="info" @click="handleOper('submit')">{{ $t('button.submit') }}</van-button>
    </div>
    <!-- 月份选择器 -->
    <van-popup v-model="showMonthPicker" position="bottom">
      <!-- 选择年月 -->
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :title="$t('shared.title.selectYearAndMonth')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onMonthConfirm"
        @cancel="showMonthPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { surveyInputInfoApi, surveyFormInputApi } from '@/api/marketInsight'
import { Toast, Dialog } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'marketCreate',
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  data () {
    return {
      showMonthPicker: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 1),
      currentDate: new Date(),
      formData: {},
      originalData: {},
      statusDisable: false,
      formRules: [
        { field: 'exwEstimatePrice', tip: `${this.$t('form.eXWEstimatedPrice')} ${this.$t('tips.isRequired')}` },
        { field: 'retailPrice', tip: `${this.$t('form.retailPriceMoney')} ${this.$t('tips.isRequired')}` },
        { field: 'avgMonthSale', tip: `${this.$t('form.monthlyAverageSalesForKit')} ${this.$t('tips.isRequired')}` },
        { field: 'supplyRatio', tip: `${this.$t('form.consumablesRatio')} ${this.$t('tips.isRequired')}` },
        { field: 'supplyExwPrice', tip: `${this.$t('form.estimatedPriceOfConsumablesEXW')} ${this.$t('tips.isRequired')}` }
      ]
    }
  },
  activated () {
    if (this.$route.query.collectStatus === '2') {
      this.statusDisable = true
    } else {
      this.statusDisable = false
    }
    this.echoData()
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  methods: {
    onMonthConfirm (date) {
      this.originalData.month = moment(date).format('YYYY-MM')
      this.showMonthPicker = false
    },
    echoData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      surveyInputInfoApi(this.$route.query.surveyId).then(res => {
        Toast.clear()
        const { originalData } = res.data
        const rivalIdList = []
        if (originalData.rivalList.length > 0) {
          originalData.rivalList.forEach((subItem, subIndex) => {
            rivalIdList.push(subItem.rivalId)
            if (!subItem.activeNames && subIndex === 0) {
              subItem.activeNames = ['1']
            } else {
              subItem.activeNames = []
            }
          })
        }
        const selectedProducts = sessionStorage.getItem('selectedProducts')
        if (selectedProducts) {
          JSON.parse(selectedProducts).forEach((subItem, subIndex) => {
            if (!rivalIdList.includes(subItem.rivalId)) {
              if (!subItem.activeNames && JSON.parse(selectedProducts).length - 1 === subIndex) {
                subItem.activeNames = ['1']
              } else {
                subItem.activeNames = []
              }
              originalData.rivalList.unshift(subItem)
            }
          })
          sessionStorage.removeItem('selectedProducts')
        }
        if (sessionStorage.getItem('countryVal')) {
          originalData.country = sessionStorage.getItem('countryVal')
          sessionStorage.removeItem('countryVal')
        }
        this.formData = res.data
        this.originalData = originalData
      }).catch(() => {})
    },
    toUrl () {
      if (this.originalData.rivalList && this.originalData.rivalList.length > 0) {
        sessionStorage.setItem('selectedProducts', JSON.stringify(this.originalData.rivalList))
      }
      sessionStorage.setItem('countryVal', this.originalData.country)
      this.$router.push('/marketInsight/marketProductAdd')
    },
    handleCollapse (params) {
      this.originalData.rivalList.forEach(subItem => {
        if (subItem.rivalId === params.rivalId) {
          subItem.activeNames = ['1']
        } else {
          subItem.activeNames = []
        }
      })
    },
    handleOper (type, index) {
      if (type === 'del') {
        Dialog.confirm({
          title: '',
          message: this.$t('shared.titleTwentyTwo'), // 确定移除该产品吗?
          confirmButtonText: this.$t('button.remove')
        })
          .then(() => {
            this.originalData.rivalList.splice(index, 1)
          })
          .catch(() => {
            // on cancel
          })
      } else {
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        let isFlag = false
        if (!this.originalData.country) {
          Toast(`${this.$t('form.country')} ${this.$t('tips.isRequired')}`)
          return
        }
        this.originalData.rivalList.find(subItem => {
          this.formRules.find(rulesItem => {
            if (!subItem[rulesItem.field]) {
              isFlag = true
              Toast(rulesItem.tip)
              return rulesItem
            }
          })
          if (isFlag) {
            return subItem
          }
        })
        if (isFlag) {
          return
        }
        const data = {
          ...this.formData,
          originalData: this.originalData,
          surveyId: this.$route.query.surveyId
        }
        surveyFormInputApi(data).then(res => {
          Toast.clear()
          this.$router.go(-1)
        }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="less" scoped>
.market-create-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .form-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 0px;
    .info {
      margin-bottom: 20px;
      .item-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        color: #307bff;
        margin-bottom: 10px;
        &::before {
          content: '';
          width: 6px;
          height: 12px;
          margin-right: 3px;
          background-color: #307bff;
        }
      }
      .title-custom {
        justify-content: space-between;
        padding-right: 12px;
        &::before {
          display: none;
        }
        .left-title {
          display: flex;
          align-items: center;
          &::before {
            content: '';
            width: 6px;
            height: 12px;
            margin-right: 3px;
            background-color: #307bff;
          }
        }
        .right-group {
          font-weight: 400;
        }
      }
      .product-item {
        margin: 0 10px;
        margin-bottom: 10px;
        padding: 0 16px;
        background-color: #f7f7f7;
        border-radius: 12px;
        .product-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0;
          border-bottom: 1px solid #f0ecec;
        }
        .title-txt {
          .product-name {
            margin-bottom: 8px;
            font-size: 13px;
            color: #307bff;
            font-weight: bold;
          }
          .other-name {
            color: #7f7f7f;
          }
        }
        .remove-icon {
          width: 20px;
          height: 20px;
        }
        .product-form {
          padding: 10px 0px;
          /deep/.van-collapse {
            .van-collapse-item__title {
              background-color: #f7f7f7;
              padding: 0;
              padding-bottom: 10px;
              font-size: 12px;
            }
            .collapse-title {
              display: flex;
              align-items: center;
              .desc-icon {
                font-size: 14px;
                color: #307bff;
                margin-right: 3px;
              }
            }
            .van-collapse-item__title--expanded::after {
              display: none;
            }
            .van-collapse-item__content {
              padding: 0;
              background-color: #f7f7f7;
            }
          }
          /deep/.van-hairline--top-bottom::after {
            border: none;
          }
          // .van-collapse-item__title::after {
          //   display: none;
          // }
        }
      }
    }
    .form-item {
      padding: 0 10px;
      margin-bottom: 13px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
    }
    .product-form-item {
      padding: 0;
    }
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
}
</style>
